import React from "react";
import Close from "../../assets/cancel.svg";
import AddTable from "../../common/AddTable";
import { NavWrap } from "../ShopForTyres";
import "./claims.css";

const RetailerOwnerForm = () => {
  return (
    <form>
      <div>
        <span>Name</span>
        <input />
      </div>
      <div>
        <span>Address</span>
        <textarea />
      </div>
      <div>
        <span>City</span>
        <input />
      </div>
      <div className="row">
        <div>
          <span>State</span>
          <input />
        </div>
        <div className="ml2">
          <span>Postal code</span>
          <input className="n-ml2" />
        </div>
      </div>
    </form>
  );
};

const NewClaim = () => {
  const vehicleInfo = [
    { header: "Year", key: "year", width: 20 },
    { header: "Make", key: "make", width: 20 },
    { header: "Model", key: "model", width: 20 },
    { header: "Split Fitment", key: "splitFitment", width: 20 },
    {
      header: "Vehicle Identification number",
      key: "vehicleIdenficationNo",
      width: 20,
    },
  ];

  const TitleInfo = [
    { header: "SKU", key: "sku", width: 20 },
    { header: "Brand & Pattern", key: "brandNpattern", width: 20 },
    { header: "Size", key: "size", width: 20 },
    { header: "Tyre Mileage at time of Removal", key: "tyreMilage", width: 25 },
    {
      header: "Date of Purchase",
      key: "dateOfPurchase",
      width: 20,
    },
  ];

  const replacement = [
    { header: "Invoice No", key: "invoice_no", width: 33 },
    { header: "Brand & Pattern", key: "brandNpattern", width: 33 },
    { header: "Size", key: "size", width: 33 },
  ];

  return (
    <NavWrap>
      <div className="m2 claim-card">
        <span className="close">
          <img src={Close} alt="close" width={15} />
        </span>
        <div className="flex-between ml2 mr2 head-sec">
          <h3>Create Claim</h3>
          <button>Submit claim</button>
        </div>
        <div className="d-flex retail-owner-info">
          <section className="w50 br-right">
            <h3>Retailer Information</h3>
            <RetailerOwnerForm />
          </section>
          <section className="w50">
            <h3>Owner Info</h3>
            <RetailerOwnerForm />
          </section>
        </div>
        <div className="w80">
          <AddTable
            columns={vehicleInfo}
            values={{
              year: "",
              make: "",
              model: "",
              splitFitment: "",
              vehicleIdenficationNo: "",
            }}
            label={"Vehicle Information"}
          />
        </div>
        <div className="w80">
          <AddTable
            columns={TitleInfo}
            values={{
              sku: "",
              brandNpattern: "",
              size: "",
              tyreMilage: "",
              dateOfPurchase: "",
            }}
            label={"Title Information"}
          />
        </div>
        <div className="w60">
          <AddTable
            columns={replacement}
            values={{
              invoice_no: "",
              brandNpattern: "",
              size: "",
            }}
            label={"Replacement Tyre Provided"}
          />
        </div>
      </div>
    </NavWrap>
  );
};

export default NewClaim;
